function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Style-guide-/-Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Nav/My-Cards/Active",
  className: "stroke",
  transform: "translate(-42.000000, -16.000000)",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "Home/Active"
}, /*#__PURE__*/React.createElement("g", {
  id: "travelsim_logo-copy",
  transform: "translate(44.000000, 18.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.3231111,1.52876061 L18.3551407,1.52876061 C19.0871655,1.52876061 19.6666667,2.12634265 19.6666667,2.84803485 L19.6666667,13.6807576 C19.6666667,14.4027424 19.0838844,15 18.3551407,15 L2.36262963,15 C2.00672551,15 1.66909795,14.8540294 1.42585754,14.6046524 L-0.641299384,12.4827962 C-0.866726049,12.2403991 -1,11.9197226 -1,11.5757727 L-1,2.84803485 C-1,2.12599395 -0.41725885,1.52876061 0.311524889,1.52876061 L5.34076593,1.52876061 L5.34076593,0.319273182 C5.34076593,-0.40595265 5.92395579,-1 6.65229185,-1 L12.0143852,-1 C12.7471279,-1 13.3345173,-0.397974251 13.3231111,0.319273182 L13.3231111,1.52876061 Z M8.62545778,1.52876061 L8.62545778,1.48617424 C8.62545778,1.50044585 8.62508447,1.51464467 8.62434643,1.52876061 L7.80189926,1.52876061 C8.10190132,1.52876061 8.35862325,1.68510924 8.5023736,1.91564015 C8.35862325,2.14617106 8.10190132,2.3025197 7.80189926,2.3025197 L8.62434643,2.3025197 C8.62508447,2.31663563 8.62545778,2.33083446 8.62545778,2.34510606 L8.62545778,2.3025197 L10.0412296,2.3025197 L10.0412296,2.34510606 C10.0412296,2.33083439 10.0416029,2.31663556 10.0423409,2.3025197 L10.8647259,2.3025197 C10.5647011,2.3025197 10.3083751,2.14521582 10.1646721,1.91506113 C10.3084939,1.6848383 10.5650375,1.52876061 10.8647259,1.52876061 L10.0423542,1.52876061 C10.0416074,1.51463933 10.0412296,1.50044033 10.0412296,1.48617424 L10.0412296,1.52876061 L8.62545778,1.52876061 Z",
  id: "Combined-Shape"
})))));

var SvgTravelsimLogoLine = function SvgTravelsimLogoLine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "18px",
    viewBox: "0 0 23 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTravelsimLogoLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/travelsim-logo-line.37e7c713.svg";
export { ForwardRef as ReactComponent };